import React, { useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import { Stack, Chip, useMediaQuery } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import CustomRow from './CustomRow';
import CustomEmptyTable from '../../../../common/CustomEmptyTable';

const DelightsTable = ({ data, handleShowDetails }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  let noData = Boolean(!data || data?.length === 0);
  const columns = [
    {
      name: 'index',
      label: isMobile ? 'Requests' : 'No',

      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const delight = tableMeta.rowData;
          return isMobile ? <CustomRow delight={delight} /> : <span>{tableMeta.rowIndex + 1}</span>;
        },
      },
    },
    {
      name: 'outingType',
      label: 'Outing Type',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : true,
      },
    },
    {
      name: 'numberOfMembers',
      label: 'Number Of Members',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : true,

        customBodyRender: (value) => (
          <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            {value}
            <div></div>
          </div>
        ),
      },
    },
    {
      name: 'dateApplied',
      label: 'Date Applied',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : true,
      },
    },
    {
      name: 'hrStatus',
      label: 'HR Status',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : true,

        customBodyRender: (value) => (
          <Stack direction={'row'}>
            <Chip
              style={{
                backgroundColor:
                  value === 'Pending'
                    ? 'rgba(255, 193, 7, 0.16)'
                    : value === 'Approved'
                    ? 'rgba(84, 214, 44, 0.16)'
                    : 'rgba(255, 72, 66, 0.16)',
                color: value === 'Pending' ? '#B78103' : value === 'Approved' ? '#229A16' : '#B72136',
                borderRadius: '6px',
                width: '5.5rem',
                fontWeight: 'bold',
              }}
              label={value}
            />
          </Stack>
        ),
      },
    },
    {
      name: 'adminStatus',
      label: 'Admin Status',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : true,

        customBodyRender: (value) => (
          <Stack direction={'row'}>
            <Chip
              style={{
                backgroundColor:
                  value === 'Pending'
                    ? 'rgba(255, 193, 7, 0.16)'
                    : value === 'Approved'
                    ? 'rgba(84, 214, 44, 0.16)'
                    : 'rgba(255, 72, 66, 0.16)',
                color: value === 'Pending' ? '#B78103' : value === 'Approved' ? '#229A16' : '#B72136',
                borderRadius: '6px',
                width: '5.5rem',
                fontWeight: 'bold',
              }}
              label={value}
            />
          </Stack>
        ),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        display: isMobile ? false : true,

        customBodyRender: (value, tableMeta) => (
          <Stack spacing={2} direction={'row'}>
            <Visibility
              onClick={() => handleShowDetails(data[tableMeta.rowIndex])}
              sx={{ cursor: 'default' }}
              aria-label='view'
            />
          </Stack>
        ),
      },
    },
  ];

  // Create table data with additional formatting if needed
  const tableData = useMemo(() => {
    return data?.map((request, index) => ({
      index: index + 1,
      ...request,
      hrStatus: request.hrStatus,
      adminStatus: request.adminStatus,
      requestorName: request.requesterUser?.username,
      dateApplied: new Date(request.dateRequested).toLocaleDateString(),
      outingType: request.requestType,
    }));
  }, [data]);

  const handleRowClick = (row, { rowIndex }) => {
    handleShowDetails(data[rowIndex]);
  };
  // Calculate table body height dynamically
  const tableBodyMaxHeight = useMemo(() => {
    const rowsPerPage = 14; // Rows per page option
    const rowHeight = 29; // Height of each row
    const headerHeight = 48; // Height of table header
    const paginationHeight = 56; // Height of pagination

    // Calculate maximum height of the table body
    return rowsPerPage * rowHeight + headerHeight + paginationHeight + 'px';
  }, []);

  return (
    <MUIDataTable
      title={""}
      data={tableData}
      columns={columns}
      options={{
        elevation: 0,
        selectableRows: false,
        rowsPerPage: 7,
        rowsPerPageOptions: [7, 14, 21],
        viewColumns: false,
        search: false,
        searchOpen: false,
        download: false,
        filter: false,
        print: false,
        tableBodyHeight: `calc(100vh - ${isMobile ? '405px' : '360px'})`,
        onRowClick: handleRowClick,
        responsive: 'standard',
      }}
      components={{
        ...(noData && {
          TableBody: CustomEmptyTable,
        }),
      }}
    />
  );
};

export default DelightsTable;
